import axios from "axios";
import store from "@/store";

import { apiConfig } from "@/apis/apiConfig.js";

const config = apiConfig;

/**
 * Enum for HTTP method types.
 * @readonly
 * @enum {string}
 */
const MethodType = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
};

/**
 * Makes an axios HTTP request with the specified method, URL, and payload.
 *
 * @param {string} method - The HTTP method to use for the request (e.g., 'GET', 'POST').
 * @param {string} url - The URL to which the request is sent.
 * @param {Object} payload - The data to be sent as the request body.
 * @returns {Promise<Object>} - A promise that resolves to the response object or the error response object.
 */
async function axiosCall(method, url, data) {
  if (method === MethodType.GET || method === MethodType.DELETE) {
    url += `?public_key=${store.getters.publicKey}`;
  }

  return axios({
    method,
    url,
    data,
    headers: {
      Authorization: `Bearer ${store.getters.getToken}`
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function fileCall(file) {
  return await import(`@/data/${file}.json`).then((module) => {
    return module.default;
  });
}
export { axiosCall, fileCall, MethodType, config };
